const DOWNLOAD_ERROR = 'Failed to download attachment';

export type NoteAttachmentDownloadParams =
  | { type: 'user'; noteId: string }
  | { type: 'project'; projectId: string; resourceId: string };

export async function downloadNoteAttachment(
  apiBase: string,
  token: string,
  params: NoteAttachmentDownloadParams,
  onError: (message: string) => void
): Promise<void> {
  try {
    const url =
      params.type === 'user'
        ? `${apiBase}/api/notes/${params.noteId}/attachment-download-url`
        : `${apiBase}/api/projects/${params.projectId}/resources/${params.resourceId}`;
    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error((err as { error?: string }).error || DOWNLOAD_ERROR);
    }
    const data = (await res.json()) as { downloadUrl?: string };
    if (data.downloadUrl) {
      window.open(data.downloadUrl, '_blank', 'noopener,noreferrer');
    }
  } catch (e) {
    onError(e instanceof Error ? e.message : DOWNLOAD_ERROR);
  }
}
